import { canUseDOM } from '../../components';

export const FETCH_ACCOUNT_CLIENT = 'FETCH_ACCOUNT_CLIENT';
export const FETCH_ACCOUNT = 'FETCH_ACCOUNT';
export const FETCH_ACCOUNT_START = 'FETCH_ACCOUNT_START';
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS';
export const FETCH_ACCOUNT_ERROR = 'FETCH_ACCOUNT_ERROR';

export const CONFIRM_UNREGISTERED_EMAIL = 'CONFIRM_UNREGISTERED_EMAIL';
export const CONFIRM_UNREGISTERED_EMAIL_START = 'CONFIRM_UNREGISTERED_EMAIL_START';
export const CONFIRM_UNREGISTERED_EMAIL_SUCCESS = 'CONFIRM_UNREGISTERED_EMAIL_SUCCESS';
export const CONFIRM_UNREGISTERED_EMAIL_ERROR = 'CONFIRM_UNREGISTERED_EMAIL_ERROR';

const fetchFn = (fetch, url, verb, params) => fetch(url, {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchAccount(params) {
  if (canUseDOM) {
    return () => ({
      type: FETCH_ACCOUNT_CLIENT,
    });
  }
  const url = '/portal-srp/api/v1/account';
  const verb = 'POST';
  const body = {
    site: params.apireq.site, 
    domain: params.domain, 
    locale: params.locale, 
    apireq: params.apireq, 
    baseUri: params.uri,
  };
  return ({ fetch }) => ({
    type: FETCH_ACCOUNT,
    payload: {
      promise: fetchFn(fetch, url, verb, body)
        .then(response => response.json())
        .catch(err => console.error('Error fetch account', err)),
    },
  });
}
